import { svfi } from "./svfi"
import { sv } from "./sv"
import { fi } from "./fi"
import { en } from "./en"

export const messages = {
    svfi,
    fi,
    en,
    sv
}